// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"be0c4c1b","643":"08e60415"}[chunkId] + ".chunk.css";
};